import Vue from "vue";
import axios from "axios";
import moment from "moment";
import "../../../../filters";
import ldf from "@/localDataFunctions";

export default {
  name: "removeMeter",
  mixins: [ldf],
  components: {},
  props: ["dataObj"],
  data: function () {
    return {
      appId: -1,
      appData: {
        metersToRemove: [],
        scrapMeter: false,
        reserveMeter: false,
        reserverMeterDate: null,
      },
      metersToRemove: [],
      text: "",
      scrapMeterVisible: false,
      reserveMeterVisible: false,

      reserverMeterDateView: null,

      lang: "",
      readOnly: false,
    };
  },
  watch: {
    reserverMeterDateView: function (val) {
      this.appData.reserverMeterDate = moment(val, "DD/MM/YYYY").add(1, "days");
    },
  },
  created() {
    this.$material.locale.dateFormat = "dd/MM/yyyy";
    this.$root.$on("adjustment_between_customers_updated", this.init);
    this.init();
  },
  mounted() {
    const localPreferences = this.getFromLocal("_preference");

    if (
      localPreferences &&
      localPreferences.preferenced &&
      localPreferences.meterWarehouseId &&
      Array.isArray(this.dataObj.appData.metersToRemove) &&
      this.dataObj.appData.metersToRemove.length > 0
    ) {
      this.dataObj.appData.metersToRemove.forEach((meter) => {
        meter.warehouseId = localPreferences.meterWarehouseId;
      });
    }
  },
  methods: {
    init() {
      Vue.nextTick(() => {
        this.appId = this.dataObj.appId;
        this.appData = this.dataObj.appData;
        this.readOnly = this.dataObj.readOnly;

        this.metersToRemove = this.appData.metersToRemove;
        this.scrapMeterVisible = this.appData.scrapMeterVisible;
        this.reserveMeterVisible = this.appData.reserveMeterVisible;
        this.scrapMeterVisible = this.appData.scrapMeterVisible;

        if (this.appData.reserveMeterVisible) {
          this.appData.reserveMeter = this.dataObj.appData.reserveMeter;
          this.appData.reserverMeterDate =
            this.dataObj.appData.reserverMeterDate;
          this.reserverMeterDateView = this.$options.filters.formatDateDDMMYYY(
            this.appData.reserverMeterDate
          );
        }

        console.log(this.dataObj);
      });
    },
  },
};
